// Dekoration-Bibliothek mit vordefinierten Assets
export const decorationLibrary = {
  christmas: {
    name: 'Weihnachten',
    icon: '🎄',
    items: [
      { id: 'xmas-tree', emoji: '🎄', name: 'Weihnachtsbaum', category: 'christmas' },
      { id: 'snowflake', emoji: '❄️', name: 'Schneeflocke', category: 'christmas' },
      { id: 'santa', emoji: '🎅', name: 'Weihnachtsmann', category: 'christmas' },
      { id: 'gift', emoji: '🎁', name: 'Geschenk', category: 'christmas' },
      { id: 'star', emoji: '⭐', name: 'Stern', category: 'christmas' },
      { id: 'bell', emoji: '🔔', name: 'Glocke', category: 'christmas' },
      { id: 'candy-cane', emoji: '🍭', name: 'Zuckerstange', category: 'christmas' },
      { id: 'snowman', emoji: '⛄', name: 'Schneemann', category: 'christmas' },
      { id: 'reindeer', emoji: '🦌', name: 'Rentier', category: 'christmas' },
      { id: 'candle', emoji: '🕯️', name: 'Kerze', category: 'christmas' },
    ]
  },
  easter: {
    name: 'Ostern',
    icon: '🐰',
    items: [
      { id: 'bunny', emoji: '🐰', name: 'Osterhase', category: 'easter' },
      { id: 'egg', emoji: '🥚', name: 'Osterei', category: 'easter' },
      { id: 'flower', emoji: '🌸', name: 'Blume', category: 'easter' },
      { id: 'tulip', emoji: '🌷', name: 'Tulpe', category: 'easter' },
      { id: 'butterfly', emoji: '🦋', name: 'Schmetterling', category: 'easter' },
      { id: 'chick', emoji: '🐣', name: 'Küken', category: 'easter' },
      { id: 'basket', emoji: '🧺', name: 'Körbchen', category: 'easter' },
      { id: 'rainbow', emoji: '🌈', name: 'Regenbogen', category: 'easter' },
    ]
  },
  summer: {
    name: 'Sommer',
    icon: '☀️',
    items: [
      { id: 'sun', emoji: '☀️', name: 'Sonne', category: 'summer' },
      { id: 'palm', emoji: '🌴', name: 'Palme', category: 'summer' },
      { id: 'wave', emoji: '🌊', name: 'Welle', category: 'summer' },
      { id: 'watermelon', emoji: '🍉', name: 'Wassermelone', category: 'summer' },
      { id: 'ice-cream', emoji: '🍦', name: 'Eis', category: 'summer' },
      { id: 'sunglasses', emoji: '😎', name: 'Sonnenbrille', category: 'summer' },
      { id: 'beach', emoji: '🏖️', name: 'Strand', category: 'summer' },
      { id: 'hibiscus', emoji: '🌺', name: 'Hibiskus', category: 'summer' },
    ]
  },
  autumn: {
    name: 'Herbst',
    icon: '🍂',
    items: [
      { id: 'leaf-fall', emoji: '🍂', name: 'Herbstblatt', category: 'autumn' },
      { id: 'maple', emoji: '🍁', name: 'Ahornblatt', category: 'autumn' },
      { id: 'pumpkin', emoji: '🎃', name: 'Kürbis', category: 'autumn' },
      { id: 'acorn', emoji: '🌰', name: 'Eichel', category: 'autumn' },
      { id: 'mushroom', emoji: '🍄', name: 'Pilz', category: 'autumn' },
      { id: 'fox', emoji: '🦊', name: 'Fuchs', category: 'autumn' },
      { id: 'hedgehog', emoji: '🦔', name: 'Igel', category: 'autumn' },
      { id: 'chestnut', emoji: '🌰', name: 'Kastanie', category: 'autumn' },
    ]
  },
  valentines: {
    name: 'Valentinstag',
    icon: '💝',
    items: [
      { id: 'heart-red', emoji: '❤️', name: 'Rotes Herz', category: 'valentines' },
      { id: 'heart-pink', emoji: '💖', name: 'Rosa Herz', category: 'valentines' },
      { id: 'rose', emoji: '🌹', name: 'Rose', category: 'valentines' },
      { id: 'bouquet', emoji: '💐', name: 'Blumenstrauß', category: 'valentines' },
      { id: 'gift-heart', emoji: '💝', name: 'Geschenk mit Herz', category: 'valentines' },
      { id: 'cupid', emoji: '💘', name: 'Amor', category: 'valentines' },
      { id: 'kiss', emoji: '💋', name: 'Kuss', category: 'valentines' },
      { id: 'sparkle', emoji: '✨', name: 'Glitzer', category: 'valentines' },
    ]
  },
  mothersday: {
    name: 'Muttertag',
    icon: '🌹',
    items: [
      { id: 'rose-red', emoji: '🌹', name: 'Rote Rose', category: 'mothersday' },
      { id: 'heart-mom', emoji: '💕', name: 'Herzchen', category: 'mothersday' },
      { id: 'bouquet-mom', emoji: '💐', name: 'Blumenstrauß', category: 'mothersday' },
      { id: 'gift-mom', emoji: '🎁', name: 'Geschenk', category: 'mothersday' },
      { id: 'sparkle-mom', emoji: '✨', name: 'Glitzer', category: 'mothersday' },
      { id: 'crown', emoji: '👑', name: 'Krone', category: 'mothersday' },
    ]
  },
  halloween: {
    name: 'Halloween',
    icon: '🎃',
    items: [
      { id: 'pumpkin-hal', emoji: '🎃', name: 'Kürbis', category: 'halloween' },
      { id: 'ghost', emoji: '👻', name: 'Geist', category: 'halloween' },
      { id: 'bat', emoji: '🦇', name: 'Fledermaus', category: 'halloween' },
      { id: 'spider', emoji: '🕷️', name: 'Spinne', category: 'halloween' },
      { id: 'skull', emoji: '💀', name: 'Totenkopf', category: 'halloween' },
      { id: 'witch', emoji: '🧙', name: 'Hexe', category: 'halloween' },
      { id: 'candy', emoji: '🍬', name: 'Süßigkeit', category: 'halloween' },
      { id: 'moon', emoji: '🌙', name: 'Mond', category: 'halloween' },
    ]
  },
  newyear: {
    name: 'Neujahr',
    icon: '🎆',
    items: [
      { id: 'firework', emoji: '🎆', name: 'Feuerwerk', category: 'newyear' },
      { id: 'champagne', emoji: '🍾', name: 'Champagner', category: 'newyear' },
      { id: 'party-popper', emoji: '🎉', name: 'Party Popper', category: 'newyear' },
      { id: 'clock', emoji: '🕛', name: 'Uhr', category: 'newyear' },
      { id: 'star-ny', emoji: '⭐', name: 'Stern', category: 'newyear' },
      { id: 'sparkler', emoji: '✨', name: 'Wunderkerze', category: 'newyear' },
      { id: 'balloon-ny', emoji: '🎈', name: 'Ballon', category: 'newyear' },
    ]
  },
  general: {
    name: 'Allgemein',
    icon: '✨',
    items: [
      { id: 'star-gen', emoji: '⭐', name: 'Stern', category: 'general' },
      { id: 'sparkle-gen', emoji: '✨', name: 'Glitzer', category: 'general' },
      { id: 'rainbow-gen', emoji: '🌈', name: 'Regenbogen', category: 'general' },
      { id: 'cloud', emoji: '☁️', name: 'Wolke', category: 'general' },
      { id: 'balloon', emoji: '🎈', name: 'Ballon', category: 'general' },
      { id: 'confetti', emoji: '🎊', name: 'Konfetti', category: 'general' },
      { id: 'party', emoji: '🎉', name: 'Party', category: 'general' },
      { id: 'ribbon', emoji: '🎀', name: 'Schleife', category: 'general' },
    ]
  }
};

export const getDecorationsByCategory = (category) => {
  return decorationLibrary[category]?.items || [];
};

export const getAllDecorations = () => {
  return Object.values(decorationLibrary).flatMap(cat => cat.items);
};
